<template>
    <section class="emptyState">
        <Heading :h="2" size="xxl">
            <span class="echo xxl">Hallo</span>
            <span class="echo xl">Halloo</span>
            <span class="echo l">Hallooo</span>
            <span class="echo m">Halloooo</span>
            <span class="echo s">Halloooo</span>
        </Heading>
        <Heading :h="3" size="m">
            {{ siteContent.nobodyHearsYou }}. {{ siteContent.returnToThe }} <router-link to="/">{{ siteContent.homepage }}</router-link>.
        </Heading>
    </section>
</template>

<script>
    export default {
        name: 'EmptyState'
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/variables';

    .emptyState {
        width: 100%;
        padding: 3rem 0.5rem;
    }

    .echo {
        margin-right: 2rem;
        margin-bottom: 1rem;

        &:last-of-type {
            margin: 0;
        }
    }

    .h2, .h3 {
        text-align: center;
    }

    .h2 {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: baseline;
    }
</style>